import API from './apiConfig';

const PAYOUTS_API = '/payouts';
const REGENERATION_API = '/regeneration';

export const getPayouts = async (payload) => {
  const res = await API.get(PAYOUTS_API + '/filteredPayouts', {
    withCredentials: true,
    params: payload,
  });
  return res.data;
};

export const getSearch = async (payload) => {
  const res = await API.get(PAYOUTS_API + '/search', {
    withCredentials: true,
    params: payload,
  });
  return res.data;
};

export const updatePayoutStatus = async (payoutId, filterRequest, status) => {
  const res = await API.post(PAYOUTS_API + '/updatePayouts', {
    payoutIds: payoutId,
    filterRequest,
    ...status,
  });
  return res.data;
};

export const getPayoutsAndInvoices = async (payoutId) => {
  const res = await API.get(PAYOUTS_API + '/relatedPayoutsAndInvoices', {
    params: {
      payoutId,
    },
  });
  return res.data;
};

export const getPayoutCSV = async (payload) => {
  const response = await API.get(PAYOUTS_API + '/exportCSV', {
    headers: {
      'Content-Type': 'application/json',
    },
    params: payload,
    responseType: 'blob',
    withCredentials: true,
    timeout: 1000 * 60 * 15,
  });
  return response.data;
};

export const createPayoutEvent = async (payload) => {
  const res = await API.post(PAYOUTS_API + '/createPayoutEvent', payload, {
    withCredentials: true,
  });
  return res;
};

export const generatePayoutWithOverride = async (invoiceId, payload) => {
  const res = await API.post(
    PAYOUTS_API + `/${invoiceId}/generateWithOverride`,
    payload,
    {
      withCredentials: true,
      // Resolve the permission/eligibility failures so the caller can surface the
      // backend message. The shared interceptor swallows rejections, so anything
      // left to reject here comes back as undefined.
      validateStatus: (status) =>
        (status >= 200 && status < 300) || [403, 404, 409].includes(status),
    },
  );
  return res;
};

export const completeFailedPayout = async (payoutId, payload) => {
  const res = await API.post(
    PAYOUTS_API + `/${payoutId}/completeFailedPayout`,
    payload,
    {
      withCredentials: true,
      // Resolve the permission/eligibility failures so the caller can surface the
      // backend message. The shared interceptor swallows rejections, so anything
      // left to reject here comes back as undefined.
      validateStatus: (status) =>
        (status >= 200 && status < 300) || [403, 404, 409].includes(status),
    },
  );
  return res;
};

export const defaultRail = async (payload) => {
  const res = await API.post(PAYOUTS_API + `/changeRail`, payload, {
    withCredentials: true,
  });
  return res.data;
};

export const startRegenerate = async (payload) => {
  const res = await API.post(REGENERATION_API + '/start', payload, {
    withCredentials: true,
  });
  return res.data;
};

export const regenerateStatus = async (Id) => {
  const res = await API.get(REGENERATION_API + `/status/${Id}`, {
    withCredentials: true,
  });
  return res.data;
};

export const getRegenerateExport = async (id) => {
  const response = await API.get(REGENERATION_API + '/failureExport', {
    headers: {
      'Content-Type': 'application/json',
    },
    params: { taskId: id },
    responseType: 'blob',
    withCredentials: true,
    timeout: 1000 * 60 * 15,
  });
  return response.data;
};
